<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">部門編集</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form ref="form" class="pa-2" v-model="valid">
				<v-text-field
					v-model="name"
					:rules="[rules.requiredValue]"
					label="部門名(必須)"
					class="mt-4"
					dense
					outlined
				/>

				<v-card-actions>
					<v-row no-gutters class="pb-2">
						<v-col sm="4" cols="0" />
						<v-col sm="4" cols="12">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="updateDepartment()" :disabled="!valid">
									<v-icon class="mr-1">mdi-pencil</v-icon>
									編集する
								</v-btn>
							</v-row>
						</v-col>
						<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="showDialog = false"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"

export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		department: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			name: "",
			rules: rules,
			valid: false,
			mainTitle: "部門編集",
			subTitle: "部門名入力",
		}
	},

	methods: {
		updateDepartment() {
			if (!this.$refs.form.validate()) return
			const headers = authenticate.setHeader()
			const formData = new FormData()
			formData.append("department[name]", this.name)
			axios
				.put(`/erp/v1/departments/${this.department.id}`, formData, { headers })
				.then((res) => {
					this.$store.commit("updateDepartment", res.data)
					this.$emit("update-department", res.data)
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
					this.showDialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		department(val) {
			this.name = val.name
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				return this.$emit("update:dialog", val)
			},
		},
	},
}
</script>

<style lang="scss" scoped >
.department-form {
	max-width: 800px;
	margin: 0 auto;
}
</style>
